import React, { useState } from "react";
import axios, { authIsValid } from "../axios";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";

function Delete({ itemId, itemToDelete, setVisibility, updateList }) {
  const navigate = useNavigate();
  const [cookies, setCookies] = useCookies();
  const [confirmDeleteInput, setConfirmDeleteInput] = useState("");
  const [wrongInput, setWrongInput] = useState(false);
  const [itemDeleted, setItemDeleted] = useState(false);
  const itemString =
    itemToDelete.substring(0, 1).toUpperCase() + itemToDelete.substring(1);
  //console.log("itemToDelete: ", itemId);

  const handleCancel = () => {
    if (itemDeleted) {
      setVisibility();
      updateList();
    } else {
      setVisibility();
    }
  };

  const handleDelete = async () => {
    if (confirmDeleteInput === "delete me daddy") {
      try {
        if (itemToDelete === "user") {
          const response = await axios.put(
            "/users/delete",
            { userId: itemId },
            { headers: { "x-access-token": cookies.access_token } }
          );
          if (response.data.message) {
            alert(response.data.message);
          } else {
            setItemDeleted(true);
          }
        } else if (itemToDelete === "formula") {
          const response = await axios.put(
            "/formulas/delete",
            { formulaId: itemId },
            { headers: { "x-access-token": cookies.access_token } }
          );
          if (response.data.message) {
            if (authIsValid(response.data.message) === false) {
              navigate("/mixer");
            } else {
              alert(response.data.message);
            }
          } else {
            setItemDeleted(true);
          }
        }
      } catch (err) {
        console.error(err);
      }
    } else {
      setConfirmDeleteInput("");
      setWrongInput(true);
    }
  };

  return (
    <div className="confirmDeleteContainer">
      <div className="confirmDelete">
        <h4 className="futuraBold">
          {itemDeleted ? `${itemString} Deleted` : "Confirm Delete"}
        </h4>
        <p>
          {itemDeleted
            ? itemToDelete === "user"
              ? "Congrats! You now have one less friend."
              : "Formula successfully removed."
            : 'Type "delete me daddy" below to confirm delete.'}
        </p>
        {!itemDeleted && (
          <>
            <input
              id="confirmDeleteInput"
              className="form-control input-lg"
              value={confirmDeleteInput}
              onChange={(e) => setConfirmDeleteInput(e.target.value)}
            />
            {wrongInput && <p>Wrong input</p>}
          </>
        )}
        <div>
          <button
            className="cancelDelete btn btn-md"
            type="button"
            style={{
              color: "#353638",
              backgroundColor: "#eaeaea",
            }}
            onClick={handleCancel}
          >
            {itemDeleted ? "Close" : "Cancel"}
          </button>
          {!itemDeleted && (
            <button
              className="confirmDeleteButton btn"
              type="button"
              onClick={handleDelete}
            >
              Delete
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default Delete;
